const $inject = ['$q', '$http', '$rootScope'];

const subNavService = function () {
  const service = {
    navObj: {},
  };

  return service;
};

subNavService.$inject = $inject;

export default subNavService;


// WEBPACK FOOTER //
// ./src/services/subNavService.js